export default "__VITE_ASSET__CluRrAYo__"